import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { UpperCasePipe, CommonModule } from '@angular/common';
import { TranslatePipe } from '@app/common-codes/components/directives/TranslatePipe';

@Component({
  selector: 'app-upload-document',
  standalone: true,
  imports: [UpperCasePipe, CommonModule, TranslatePipe],
  templateUrl: './upload-document.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: ``
})
export class UploadDocumentComponent {

  files: File[] = [];
  //evenement pour notifier le parent
  @Output() filesChanged = new EventEmitter<File[]>();
  //MaxFiles en input
  @Input() maxFiles: number = 1;
  onFileAdded(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files) return;

    // Ajouter les fichiers sélectionnés au tableau
    for (let i = 0; i < input.files.length; i++) {
      this.files.push(input.files[i]);
    }
    this.filesChanged.emit(this.files);
  }

  removeFile(index: number) {
    this.files.splice(index, 1);
    this.filesChanged.emit(this.files);
    // Reset the file input to allow reselecting the same file
    const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  getFileExtension(name: string): string {
    return name.split('.').pop() || 'file';
  }

  getBadgeColor(filename: string): string {
    const ext = this.getFileExtension(filename).toLowerCase();

    switch (ext) {
      case 'pdf':
        return 'bg-blue-500';
      case 'jpg':
      case 'jpeg':
      case 'png':
        return 'bg-green-500';
      case 'doc':
      case 'docx':
        return 'bg-indigo-500';
      default:
        return 'bg-gray-400';
    }
  }

}
